// Purpose: Purchase Order analytics API calls
// Caller: poAction
// Dependencies: utils/xhr
// Main Functions: getPOAnalytics, getPORecommendations, resetPO
// Side Effects: HTTP GET /po-analytics, HTTP GET /po-analytics/recommendations

import { xhr } from 'utils'

export const getPOAnalytics = (filter, params = '') =>
  xhr.get(`/po-analytics?filter=${filter}&${params}`)

export const getPORecommendations = (params = '') =>
  xhr.get(`/po-analytics/recommendations?${params}`)

export const resetPO = () => ({})
